import { defineComponent as _defineComponent } from 'vue'
import InlineSvg from "vue-inline-svg";
import { inject, onMounted, ref } from "vue";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";
import { useLineStore } from "@/stores/lineStore";
import {
  IBusStopLayout,
  IBusStopLayoutInfo,
} from "@/domain/entities/lineInfo/busStopLayout.types";
import { convertToRangeGateNames } from "@/utils/convertToRangeGateNames";
import { nextTick } from "vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "BusStopLayoutModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  turnUid: {
    type: String,
    required: true,
  },
  busStopUid: {
    type: String,
    required: true,
  },
  busStopName: {
    type: String,
    required: true,
  },
},
  emits: ["onClickCloseBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const route = useRoute();
const lineStore = useLineStore();
const shouldShowModal = ref(false);
const layoutInfo = ref<IBusStopLayoutInfo>();
// const colors = ["#616161", "#7e7e7e", "#9e9e9e", "#bdbdbd"];

const isRowEmpty = (row: IBusStopLayout[]): boolean => {
  return row.every((column) => column.gateNo === "");
};

const isGateNo = (gateNo: string) => {
  return layoutInfo.value?.gateNo.includes(gateNo);
};

// let lastUsedColorIndex = -1;
// const getColumnColorClass = (column: IBusStopLayout, rowIndex: number) => {
//   if (column.gateNo === "") return "white";
//   if (layoutInfo.value?.gateNo.includes(column.gateNo)) return "primary";

//   // row의 첫 번째 column일 때만 색상 인덱스를 증가
//   if (column.columnNo === 1) {
//     lastUsedColorIndex = (lastUsedColorIndex + 1) % colors.length;
//   }

//   return `gray${lastUsedColorIndex + 1}`;
// };

const closeModal = () => {
  route.meta.onBackHandlerList.pop();
  shouldShowModal.value = false;
  setTimeout(() => {
    emit("onClickCloseBtn");
  }, 300);
};

const handleError = (title: string, result: any) => {
  showErrorModal(
    title,
    result.errorMessage,
    result.resultCode,
    result.errorTime
  );
};

const getLayoutInfo = async () => {
  const infoResult = await lineStore.getBusStopLayoutInfo(
    props.turnUid,
    props.busStopUid
  );

  if (!infoResult.isSuccess) {
    closeModal();
    handleError("정류장 배치도 오류", infoResult);
    return;
  }

  shouldShowModal.value = true;
  layoutInfo.value = infoResult.data;
};

/** 첫번째 탑승 위치를 center로 스크롤 처리 */
const scrollToFirstGateNoElement = () => {
  nextTick(() => {
    setTimeout(() => {
      const firstGateNoElement = document.querySelector(
        ".layout-column.primary"
      );
      firstGateNoElement?.scrollIntoView({
        inline: "center",
        behavior: "smooth",
      });
    }, 500);
  });
};

onMounted(async () => {
  route.meta.onBackHandlerList.push(closeModal);
  await getLayoutInfo();
  scrollToFirstGateNoElement();
});

const __returned__ = { props, emit, showErrorModal, route, lineStore, shouldShowModal, layoutInfo, isRowEmpty, isGateNo, closeModal, handleError, getLayoutInfo, scrollToFirstGateNoElement, get InlineSvg() { return InlineSvg }, get convertToRangeGateNames() { return convertToRangeGateNames } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})